import React, { Component } from "react";
import { logoutUser } from "../actions";
import { connect } from "react-redux";

import Button from "@material-ui/core/Button";
import Tooltip from '@material-ui/core/Tooltip';
import { withStyles, makeStyles } from '@material-ui/core/styles';

import "../styles/logout_button.css";

class Logout_button extends Component {
  handleLogout = () => {
    const { dispatch } = this.props;
    dispatch(logoutUser());
  };

  render() {
    const { isLoggingOut, logoutError } = this.props;

    const LightTooltip = withStyles(theme => ({
      tooltip: {
        backgroundColor: theme.palette.common.black,
        color: '#fff',
        boxShadow: theme.shadows[1],
        fontSize: 11,
      },
    }))(Tooltip);

    return (
      <div className="header">
        <div className="logout">
          <LightTooltip enterDelay={500} title="Return to homepage">
            <Button
              onClick={this.handleLogout}
              type="button"
              fullWidth
              variant="contained"
              className='logout_button'
              disableElevation="true"
            >
              Logout
            </Button>
          </LightTooltip>

          {isLoggingOut && <p>Logging Out....</p>}
          {logoutError && <p>Error logging out</p>}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    isLoggingOut: state.auth.isLoggingOut,
    logoutError: state.auth.logoutError
  };
}

export default connect(mapStateToProps)(Logout_button);
